<template>
  <div class="reading-streak-widget-skeleton16464"></div>
</template>

<style lang="scss" scoped>
@import '@/assets.app/css/common/animations.scss';

.reading-streak-widget-skeleton16464 {
  width: 100%;
  min-height: 94px;
  border-radius: 12px;
  animation: skeleton-loading 1s linear infinite alternate;
}

.night-mode .reading-streak-widget-skeleton16464 {
  animation: skeleton-loading-night-mode 1s linear infinite alternate;
}
</style>
